const ContactAddressType = `
  id
  description
`;

export default ContactAddressType;
